import * as React from 'react';
import HideOutlined from './hide-outlined';
import HideFilled from './hide-filled';
import type { IconCombinedProps } from './types';
const HideCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <HideFilled ref={ref} {...rest} />;
  }
  return <HideOutlined ref={ref} {...rest} />;
});
export default HideCombined;